import posthog from 'posthog-js';
import { ENV } from './env';

let initialized = false;

/**
 * PostHog init. Same project key as mobile so user analytics roll up; the
 * `platform: 'web'` super-property is what distinguishes the surfaces in
 * dashboards (per plan §6).
 */
export function initPostHog(): void {
  if (initialized) return;
  if (!ENV.posthogApiKey) return;
  // Skip on Vercel preview deploys — preview events don't help product
  // analytics and inflate event budgets.
  if (ENV.vercelEnv === 'preview') return;

  posthog.init(ENV.posthogApiKey, {
    api_host: ENV.posthogHost,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: false,
    loaded: (ph) => {
      ph.register({ platform: 'web', release: ENV.release });
    },
  });

  initialized = true;
}

export function identifyUser(userId: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.identify(userId, props);
}

export function resetPostHog(): void {
  if (!initialized) return;
  posthog.reset();
}

/**
 * Manually capture an SPA route change. PostHog's `capture_pageview: true`
 * only fires on full document loads — we send a `$pageview` event ourselves
 * on every route swap.
 */
export function capturePageView(pathname: string): void {
  if (!initialized) return;
  posthog.capture('$pageview', { $current_url: window.location.href, path: pathname });
}

export { posthog };
